export default function ReparerPlutot() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="bg-white rounded-xl border border-brand-border p-6 md:p-8">
          <h2 className="text-xl md:text-2xl font-bold text-brand-blue mb-4 flex items-center gap-3">
            <span className="w-10 h-10 flex items-center justify-center rounded-full bg-brand-cyan/10 text-brand-cyan">
              <i className="ri-heart-pulse-line"></i>
            </span>
            Réparer plutôt que remplacer
          </h2>
          <p className="text-brand-text leading-relaxed mb-4">
            Un coffre de volet roulant endommagé ne signifie pas systématiquement qu'il faut remplacer l'ensemble du caisson. Dans la majorité des cas, seules quelques pièces internes sont défectueuses : une équerre de fixation corrodée, un roulement usé, un joint d'étanchéité décollé, ou une section de coque légèrement déformée. Notre approche est toujours la même : diagnostiquer précisément, réparer ce qui est réparable, et ne remplacer que ce qui est irréparable.
          </p>
          <p className="text-brand-text leading-relaxed">
            Lors de notre passage à Strasbourg ou dans le Bas-Rhin, nous inspectons le coffre dans sa globalité : fixation, structure, mécanisme interne, étanchéité. Si une réparation ciblée suffit (remplacement d'une équerre, d'un roulement, redressage d'une section), nous la réalisons. Si le coffre est trop endommagé pour une réparation durable, nous vous proposons un remplacement avec une explication claire. Devis gratuit et transparent avant tout travail.
          </p>
        </div>
      </div>
    </section>
  );
}